import axios from 'axios';

const stageString = process.env.VUE_APP_STAGE?.toUpperCase() === 'DEV' ? '-dev' : '';

const instance = axios.create({
  baseURL: `https://api${stageString}.educacionit.com`,
});

export default instance;
